import AutoSuggestButtons from './AutoSuggestButtons';

export default AutoSuggestButtons;
